"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATCH_REGEX = void 0;
exports.MATCH_REGEX = {
    MATCH_RGB_RGBA_COLOR: /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i
};
